import { formatDate, formatClassTimeRange, formatDateRange, formatLocalDate, DateFormat } from '@/lib';

export function useDateFormat() {
  return { 
    formatDate,
    formatClassTimeRange,
    formatDateRange,
    formatLocalDate,
  };
}

export type { DateFormat };